import React from 'react';

const Toggle = ({ 
  enabled, 
  onToggle, 
  label, 
  size = 'sm',
  disabled = false,
  className = ''
}) => {
  const sizeClasses = {
    xs: 'w-8 h-4',
    sm: 'w-11 h-6',
    md: 'w-14 h-7',
    lg: 'w-20 h-10'
  };

  const thumbSizeClasses = {
    xs: 'w-3 h-3',
    sm: 'w-5 h-5',
    md: 'w-6 h-6',
    lg: 'w-9 h-9'
  };

  const translateClasses = {
    xs: enabled ? 'translate-x-4' : 'translate-x-0',
    sm: enabled ? 'translate-x-5' : 'translate-x-0',
    md: enabled ? 'translate-x-7' : 'translate-x-0',
    lg: enabled ? 'translate-x-10' : 'translate-x-0'
  };

  return (
    <div className={`flex items-center ${className}`}>
      <button
        type="button"
        className={`
          relative inline-flex ${sizeClasses[size]} flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent 
          transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
          ${enabled 
            ? 'bg-blue-600' 
            : 'bg-gray-200'
          }
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        `}
        role="switch"
        aria-checked={enabled}
        aria-disabled={disabled}
        onClick={() => !disabled && onToggle(!enabled)}
        title={label}
      >
        <span className="sr-only">{label}</span>
        <span
          className={`
            ${thumbSizeClasses[size]} inline-block transform rounded-full bg-white shadow ring-0 
            transition duration-200 ease-in-out ${translateClasses[size]}
            ${disabled ? '' : 'hover:shadow-lg'}
          `}
        />
      </button>
      {label && (
        <span className={`ml-2 text-sm font-medium text-gray-700 ${disabled ? 'text-gray-400' : ''}`}>
          {label}
        </span>
      )}
    </div>
  );
};

export default Toggle;
